// an active record errors object has the shape:
// {key1: [messages...], key2: [messages...]}
// firstOnly returns an object where the value for each key is the first
// message in the array
export function firstOnly(errors) {
  const result = {};
  for (let key in errors) {
    if (errors[key].length > 0) {
      result[key] = errors[key][0];
    }
  }
  return result;
}